module.exports = __webpack_public_path__ + "img/2025-12-20g_3.69cc0b5e.jpg";